export const UPDATE_CHECKED_BANK_ID = 'UPDATE_CHECKED_BANK_ID';
